/**
 * Authority Add Offline Complaint View
 * Dedicated route component for Authority offline complaint creation
 */

import React, { useState } from 'react';
import { AddOfflineComplaintView } from './index';

const AuthorityAddOfflineComplaintView = () => {
  // Sample data for offline complaint form
  const [offlineComplaint, setOfflineComplaint] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    complaint: '',
    documents: []
  });

  // Handler functions
  const handleSaveOfflineComplaint = () => {
    setOfflineComplaint({
      name: '',
      mobile: '',
      email: '',
      address: '',
      complaint: '',
      documents: []
    });
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setOfflineComplaint(prev => ({
      ...prev,
      documents: [...prev.documents, ...files.map(file => file.name)]
    }));
  };

  const handleClearOfflineForm = () => {
    setOfflineComplaint({
      name: '',
      mobile: '',
      email: '',
      address: '',
      complaint: '',
      documents: []
    });
  };

  const handleRemoveDocument = (index) => {
    setOfflineComplaint(prev => ({
      ...prev,
      documents: prev.documents.filter((_, i) => i !== index)
    }));
  };

  return (
    <AddOfflineComplaintView
      offlineComplaint={offlineComplaint}
      onComplaintChange={setOfflineComplaint}
      onFileUpload={handleFileUpload}
      onRemoveDocument={handleRemoveDocument}
      onClearForm={handleClearOfflineForm}
      onSaveComplaint={handleSaveOfflineComplaint}
    />
  );
};

export default AuthorityAddOfflineComplaintView;
